import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Spinner,
  Button,
} from "react-bootstrap";
import "../styles/Home.css";
import InfoHeader from "../components/InfoHeader";
import { FiEye } from "react-icons/fi";
import { FiShoppingBag } from "react-icons/fi";
import { FiSettings } from "react-icons/fi";
import { FiShield } from "react-icons/fi";
import { FaBucket } from "react-icons/fa6";
import { FaMagnet } from "react-icons/fa";
import { MdSpeed } from "react-icons/md";
import UnsafeEventsModal from "../components/UnsafeEventsModal";
import { fetchTurmericData, fetchRTCData, fetchCorianderHistoryData, fetchPackagingData, createWebSocketConnection } from "../components/API/Api";
import { SiTraefikmesh } from "react-icons/si";
import { FaHistory } from "react-icons/fa"; // Add this new icon import
import CleaningHistoryModal from "../components/MagneticGrillCleanModal";
import RecentUnsafeEventsModal from "../components/RecentUnsafeEventsModal";

const Home = () => {
  const [showUnsafeModal, setShowUnsafeModal] = useState(false);
  const [data, setData] = useState(null);
  const [, setShowModal] = useState(false);
  const [, setLoading] = useState(false);
  const [, setError] = useState(null);
  const [, setDateRange] = useState([new Date(), new Date()]);
  // const [data, setData] = useState([]);
  const [, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    rowsPerPage: 5,
  });
  const [metrics, setMetrics] = useState({
    totalSackCount: 0,
    totalThreadCount: 0,
    lastThreadTimestamp: null,
  });

  const [hasWebSocketData, setHasWebSocketData] = useState({
    hopper1: false,
    hopper2: false
  });

  const [sackCount, setSackCount] = useState(0);
  const [rtcData, setRtcData] = useState({
    premixer1: {
      magneticRodCleaning: "---",
      safetyMeshLifted: false,
      lid_presence: null,
    },
    premixer2: {
      magneticRodCleaning: "---",
      safetyMeshLifted: false,
      lid_presence: null,
    },
    finalmixer1: {
      magneticRodCleaning: "---",
      safetyMeshLifted: "",
      lid_presence: null,
    },
    finalmixer2: {
      magneticRodCleaning: "---",
      safetyMeshLifted: false,
      lid_presence: null,
    },
    grinder1: {
      sackCount: 0,
      bucketCount: 0,
    },
    grinder2: {
      sackCount: 0,
      bucketCount: 0,
    },
  });
  const [rtcUnsafeEvents, setRtcUnsafeEvents] = useState({
    premixer1: [],
    premixer2: [],
    finalmixer1: [],
    finalmixer2: [],
  });

  const [rtcCleaningHistory, setRtcCleaningHistory] = useState({
    premixer1: [],
    premixer2: [],
    finalmixer1: [],
    finalmixer2: [],
  });

  const [rtcRecentUnsafeEventData, setRtcRecentUnsafeEventData] = useState({
    premixer1: {
      last_safety_mesh_presence_timestamp: null,
      last_safety_mesh_presence_image: null,
    },
    premixer2: {
      last_safety_mesh_presence_timestamp: null,
      last_safety_mesh_presence_image: null,
    },
    finalmixer1: {
      last_safety_mesh_presence_timestamp: null,
      last_safety_mesh_presence_image: null,
    },
    finalmixer2: {
      last_safety_mesh_presence_timestamp: null,
      last_safety_mesh_presence_image: null,
    }
  });

  const [packagingCleaningHistory, setPackagingCleaningHistory] = useState({
    metal_calibration_history: {},
    coin_metal_calibration_history: {}
  });

  const [tapeMissalignmentHistory, setTapeMissalignmentHistory] = useState([]);

  const [hasRtcWebSocketData, setHasRtcWebSocketData] = useState({
    premixer1: false,
    premixer2: false,
    finalmixer1: false,
    finalmixer2: false,
    grinder1: false,
    grinder2: false
  });

  const [, setCardData] = useState({});
  const [currentRtcComponent, setCurrentRtcComponent] = useState("premixer1");
  const [currentCardType, setCurrentCardType] = useState("magnetic_grill");
  const [turmericData, setTurmericData] = useState({
    hopper1: {
      sackCount: 0,
      magneticGrillCleaning: "---",
      magneticGrillPresence: true,
      safetyMeshPresence: true,
      lidPresence: null,
      magneticGrillCleaning_image: null,
    },
    hopper2: {
      sackCount: 0,
      magneticGrillCleaning: "---",
      magneticGrillPresence: true,
      safetyMeshPresence: true,
      lidPresence: null,
      magneticGrillCleaning_image: null,
    },
  });
  const [recentUnsafeEventData, setRecentUnsafeEventData] = useState({
    hopper1: {
      last_safety_mesh_presence_timestamp: null,
      last_safety_mesh_presence_image: null,
      last_magnetic_grill_presence_timestamp: null,
      last_magnetic_grill_presence_image: null,
    },
    hopper2: {
      last_safety_mesh_presence_timestamp: null,
      last_safety_mesh_presence_image: null,
      last_magnetic_grill_presence_timestamp: null,
      last_magnetic_grill_presence_image: null,
    }
  });
  const [, setCleaningImage] = useState(null)
  const [unsafeEvents, setUnsafeEvents] = useState({
    hopper1: [],
    hopper2: [],
  });
  const [turmericCleaningHistory, setTurmericCleaningHistory] = useState({
    hopper1: [],
    hopper2: []
  });
  const [packagingData, setPackagingData] = useState({
    metalDetectorCalibration: "---",
    coinMetalDetectorCalibration: "---",
    coinMetalDetectorType: "coin",
    tapeAlignmentCount: 0,
    packetCount: 0,
  });

  const [hasPackagingWebSocketData, setHasPackagingWebSocketData] = useState(false);
  const [currentHopper, setCurrentHopper] = useState("hopper1");
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentCleaningComponent, setCurrentCleaningComponent] = useState(null);
  const [, setCurrentCleaningType] = useState(null);
  const [showTurmericModal, setShowTurmericModal] = useState(false);
  const [showRtcModal, setShowRtcModal] = useState(false);
  const [showPackagingModal, setShowPackagingModal] = useState(false);
  const [openRecentUnsafeEventsModal, setOpenRecentUnsafeEventsModal] = useState(false);
  const [showTapeMissalignmentModal, setShowTapeMissalignmentModal] = useState(false);

  const formatIfTimestamp = (
    val,
    options = { showDate: true, showTime: true }
  ) => {
    if (
      typeof val === "string" &&
      (val.includes("T") || val.match(/\d{2}:\d{2}/))
    ) {
      const date = new Date(val);
      if (!isNaN(date)) {
        const formattedDate = options.showDate
          ? date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          : "";

        const formattedTime = options.showTime
          ? date.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })
          : "";

        if (options.showDate && options.showTime) {
          return `${formattedDate}, ${formattedTime}`;
        }
        return formattedDate || formattedTime;
      }
    }
    return val;
  };

  const navigate = useNavigate();

  useEffect(() => {
    const ws = createWebSocketConnection({
      setSackCount,
      setTurmericData,
      setHasWebSocketData,
      setUnsafeEvents,
      setRtcData,
      setHasRtcWebSocketData,
      setRtcUnsafeEvents,
      formatIfTimestamp,
      setPackagingData,
      setHasPackagingWebSocketData
    });

    return () => {
      ws.close();
    };
  }, []);

  useEffect(() => {
    const today = new Date();
    setDateRange([today, today]);
    fetchCorianderData(1, today, today);

    // Fetch turmeric metrics data
    fetchTurmericMetricsData(today, today);
    fetchCardData(today, today);
    fetchPackagingMetricsData(today, today);
    const intervalId = setInterval(() => {
      const currentDate = new Date();
      // fetchData(1, currentDate, currentDate);
      fetchCorianderData(1, currentDate, currentDate);
      fetchTurmericMetricsData(currentDate, currentDate);
      fetchCardData(currentDate, currentDate);
      fetchPackagingMetricsData(currentDate, currentDate);
    }, 30000); // 30 seconds interval
    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const checkWebSocketData = () => {
      setTimeout(() => {
        if (!hasWebSocketData.hopper1 || !hasWebSocketData.hopper2) {
          console.log("No WebSocket data received, falling back to API");
          const today = new Date();
          fetchTurmericMetricsData(today, today);
        }
      }, 15000); // 15 seconds timeout
    };

    const checkRtcWebSocketData = () => {
      // If no WebSocket data received for 30 seconds, fetch from API
      setTimeout(() => {
        const hasAnyRtcData = Object.values(hasRtcWebSocketData).some(value => value);
        if (!hasAnyRtcData) {
          console.log("No RTC WebSocket data received, falling back to API");
          const today = new Date();
          fetchCardData(today, today);
        }
      }, 15000); // 15 seconds timeout
    };

    const checkPackagingWebSocketData = () => {
      setTimeout(() => {
        if (!hasPackagingWebSocketData) {
          console.log("No Packaging WebSocket data received, falling back to API");
          const today = new Date();
          fetchPackagingMetricsData(today, today);
        }
      }, 15000);
    };

    checkWebSocketData();
    checkRtcWebSocketData();
    checkPackagingWebSocketData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasWebSocketData, hasRtcWebSocketData, hasPackagingWebSocketData]);

  useEffect(() => {
    // Instead of fetching, use the provided JSON data directly
    const jsonData = {
      Coriander: {
        "Sack emptying count": "123",
        "Thread removal from hopper": "123",
      },
      RTC: {
        "Magnetic rod/plate cleaning time (CCP)": "23 Apr 2025, 5:30 PM",
        "Safety mesh lifted (unsafe activity)": true,
        "Grinder machine productivity": {
          "Detected Sack count": 43,
          "Detected Bucket count": 21,
        },
      },
      Packaging: {
        "Metal detector calibration activity (CCP)": "---",
        "Rejector coil and metal detector calibration activity (coin test pieces)":
          "--",
        "Packet count": 0,
        "Tape Alignment": true,
      },
    };

    // Convert the JSON data to the format expected by the component
    const convertedData = {
      cards: Object.keys(jsonData).map((title) => {
        const metrics = Object.entries(jsonData[title]).map(
          ([label, value]) => {
            return { label, value };
          }
        );

        return { title, metrics };
      }),
    };

    setData(convertedData);
  }, []);

  const fetchPackagingMetricsData = async (startDate, endDate) => {
    try {
      const result = await fetchPackagingData(startDate, endDate);
      // console.log("Full API Response:", result);
      if (result.success) {
        // Complete response check karein
        const responseData = result.body?.success || result.data;
        // Destructured data (jo pehle use kar rahe the)
        const { data } = result;
        // console.log("Summary Data:", data);

        if (!hasPackagingWebSocketData) {
          setPackagingData(prevData => ({
            ...prevData,
            metalDetectorCalibration: data.metalDetectorCalibration
              ? formatIfTimestamp(data.metalDetectorCalibration)
              : "---",
            coinMetalDetectorCalibration: data.coinMetalDetectorCalibration
              ? formatIfTimestamp(data.coinMetalDetectorCalibration)
              : "---",
            tapeAlignmentCount: data.tapeAlignmentCount || 0,
            packetCount: data.packetCount || 0,
          }));
        }
        const tapeMissalignmentData = responseData?.tape_missalignment_history || [];
        setTapeMissalignmentHistory(tapeMissalignmentData.reverse());
        // History data correct path se set karein
        setPackagingCleaningHistory({
          metal_calibration_history: (responseData.metal_calibration_history).reverse() || [],
          coin_metal_calibration_history: (responseData.coin_metal_calibration_history).reverse() || []
        });
      } else {
        console.error("Failed to fetch packaging metrics:", result.error);
      }
    } catch (err) {
      console.error("Error in fetchPackagingMetricsData:", err);
    }
  };

  const fetchTurmericMetricsData = async (startDate, endDate) => {
    try {
      // Call the API function
      const result = await fetchTurmericData(startDate, endDate);
      // console.log("start date, end Date ==", startDate, endDate);
      if (result.success) {
        const { data } = result;
        setTurmericData((prevData) => {
          const newData = { ...prevData };

          if (!hasWebSocketData.hopper1) {
            newData.hopper1 = data.hopper1;
          }

          if (!hasWebSocketData.hopper2) {
            newData.hopper2 = data.hopper2;
          }

          return newData;
        });

        setTurmericCleaningHistory({
          hopper1: (data.hopper1?.cleaning_history).reverse() || [],
          hopper2: (data.hopper2?.cleaning_history).reverse() || []
        });
        setRecentUnsafeEventData({
          hopper1: {
            last_safety_mesh_presence_timestamp: data.hopper1?.last_safety_mesh_presence_timestamp || null,
            last_safety_mesh_presence_image: data.hopper1?.last_safety_mesh_presence_image || null,
            last_magnetic_grill_presence_timestamp: data.hopper1?.last_magnetic_grill_presence_timestamp || null,
            last_magnetic_grill_presence_image: data.hopper1?.last_magnetic_grill_presence_image || null,
          },
          hopper2: {
            last_safety_mesh_presence_timestamp: data.hopper2?.last_safety_mesh_presence_timestamp || null,
            last_safety_mesh_presence_image: data.hopper2?.last_safety_mesh_presence_image || null,
            last_magnetic_grill_presence_timestamp: data.hopper2?.last_magnetic_grill_presence_timestamp || null,
            last_magnetic_grill_presence_image: data.hopper2?.last_magnetic_grill_presence_image || null,
          }
        });

        const sortByTimestampDesc = (events = []) => {
          return [...events].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        };

        setUnsafeEvents((prevEvents) => {
          const newEvents = { ...prevEvents };

          if (!hasWebSocketData.hopper1) {
            newEvents.hopper1 = sortByTimestampDesc(data.unsafeEvents.hopper1);
          }

          if (!hasWebSocketData.hopper2) {
            newEvents.hopper2 = sortByTimestampDesc(data.unsafeEvents.hopper2);
          }

          return newEvents;
        });

      } else {
        console.error("Failed to fetch turmeric metrics:", result.error);
      }
    } catch (err) {
      console.error("Error in loadTurmericMetricsData:", err);
    }
  };

  const fetchCorianderData = async (
    page = 1,
    startDate = null,
    endDate = null,
    rowsPerPageValue = null
  ) => {
    setLoading(true);
    setError(null);

    try {
      // Call the API function
      const result = await fetchCorianderHistoryData(page, startDate, endDate, rowsPerPageValue);

      if (result.success) {
        const { data, pagination, metrics } = result.data;
        setData(data);
        setPagination(pagination);
        setMetrics(metrics);
        setError(null);
      } else {
        setError("Failed to fetch Coriander data: " + result.error);
      }
    } catch (err) {
      console.error("Error in loadCorianderData:", err);
      setError("Failed to fetch data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const fetchCardData = async (startDate = null, endDate = null) => {
    setLoading(true);
    try {
      const result = await fetchRTCData(startDate, endDate);

      if (result.success) {
        const { cardData, rtcData, unsafeEvents, cleaningHistory } = result.data;
        setCardData(cardData);
        setRtcData((prevData) => {
          const newData = { ...prevData };

          if (!hasRtcWebSocketData.premixer1) {
            newData.premixer1 = rtcData.premixer1;
          }

          if (!hasRtcWebSocketData.premixer2) {
            newData.premixer2 = rtcData.premixer2;
          }

          if (!hasRtcWebSocketData.finalmixer1) {
            newData.finalmixer1 = rtcData.finalmixer1;
          }

          if (!hasRtcWebSocketData.finalmixer2) {
            newData.finalmixer2 = rtcData.finalmixer2;
          }

          if (!hasRtcWebSocketData.grinder1) {
            newData.grinder1 = rtcData.grinder1;
          }

          if (!hasRtcWebSocketData.grinder2) {
            newData.grinder2 = rtcData.grinder2;
          }

          return newData;
        });

        if (result.body && result.body.success) {
          const rtcApiData = result.body.success;
          setRtcRecentUnsafeEventData({
            premixer1: {
              last_primix1_safety_mesh_presence_timestamp: rtcApiData.primix1?.safety_mesh_lifted_timestamp || null,
              last_primix1_safety_mesh_presence_image: rtcApiData.primix1?.safety_mesh_lifted_image || null,
            },
            premixer2: {
              last_primixer2_safety_mesh_presence_timestamp: rtcApiData.primix2?.safety_mesh_lifted_timestamp || null,
              last_primixer2_safety_mesh_presence_image: rtcApiData.primix2?.safety_mesh_lifted_image || null,
            },
            finalmixer1: {
              last_final_mixture1_safety_mesh_presence_timestamp: rtcApiData.final_mixture1?.safety_mesh_lifted_timestamp || null,
              last_final_mixture1_safety_mesh_presence_image: rtcApiData.final_mixture1?.safety_mesh_lifted_image || null,
            },
            finalmixer2: {
              last_final_mixture2_safety_mesh_presence_timestamp: rtcApiData.final_mixture2?.safety_mesh_lifted_timestamp || null,
              last_final_mixture2_safety_mesh_presence_image: rtcApiData.final_mixture2?.safety_mesh_lifted_image || null,
            }
          });
        }

        setRtcUnsafeEvents((prevEvents) => {
          const newEvents = { ...prevEvents };

          if (!hasRtcWebSocketData.premixer1) {
            newEvents.premixer1 = unsafeEvents.premixer1;
          }

          if (!hasRtcWebSocketData.premixer2) {
            newEvents.premixer2 = unsafeEvents.premixer2;
          }

          if (!hasRtcWebSocketData.finalmixer1) {
            newEvents.finalmixer1 = unsafeEvents.finalmixer1;
          }

          if (!hasRtcWebSocketData.finalmixer2) {
            newEvents.finalmixer2 = unsafeEvents.finalmixer2;
          }

          return newEvents;
        });

        setRtcCleaningHistory(cleaningHistory);
        setError(null);

      } else {
        setError("Error fetching RTC data: " + result.error);
      }
    } catch (err) {
      setError("Error in loadRTCData: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  function MetricCard({ title, value, icon, isEyeIcon, isTimestamp = false, bgColor = "white" }) {
    return (
      <div className="metric-card" style={{ backgroundColor: bgColor, }}>
        <div className="p-3">
          <div className="metric-title">{title}</div>
          <div className="d-flex align-items-center justify-content-between">
            <div className={`metric-value ${isTimestamp ? "timestamp" : ""}`}>
              {value}
            </div>
            <div>{icon}</div>
            {isEyeIcon && (
              <div style={{ width: "40px", height: "40px", marginRight: "-0.5rem" }}>
                <FiEye
                  onClick={() => setShowModal(true)}
                  close={() => setShowModal(false)}
                  style={{ cursor: "pointer" }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  function StatusCard({ title, status, icon, isEyeIcon, bgColor = "white", isLidCard = false, lidPresence = null }) {
    const getStatusText = () => {
      if (status === null || status === undefined) {
        return "No detection";
      }
      if (lidPresence === true) {
        return "Lid Closed";
      }
      if (isLidCard) {
        return status ? "Lid Closed" : "Removed";
      }
      return status ? "Present" : "Removed";
    };

    const finalStatus = lidPresence === true ? true : status;
    const statusClass = lidPresence ? "" : (finalStatus ? "success" : "danger");

    const isClickDisabled = () => {
      const statusText = getStatusText();
      return statusText === "Lid Closed" || statusText === "Present";
    };

    return (
      <div
        className="status-card"
        style={{
          backgroundColor: bgColor,
          cursor: isClickDisabled() ? "not-allowed" : "pointer",
          // opacity: isClickDisabled() ? 0.6 : 1
        }}
      >
        <div className={`status-gradient ${statusClass} ${lidPresence ? "lid-close" : ""}`}></div>
        <div className="p-3" style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="d-flex align-items-center">
            <div className={`status-icon-wrapper ${statusClass} ${lidPresence ? "lid-close" : ""}`}>
              {icon}
            </div>
            <div>
              {!lidPresence && (
                <div className="status-title">{title}</div>
              )}
              <div className={`status-value ${statusClass} ${lidPresence ? "lid-close" : ""}`}>
                {getStatusText()}
              </div>
            </div>
          </div>
          {isEyeIcon && (
            <div style={{ width: "40px", height: "40px", marginRight: "-0.5rem" }}>
              <FiEye
                onClick={() => setShowModal(true)}
                style={{ cursor: "pointer" }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  const isCardClickDisabled = (lidPresence, magneticGrillPresence) => {
    if (lidPresence === true) return true;
    if (magneticGrillPresence === true) return true;
    return false;
  };

  const handleCleaningHistoryClick = (component, type) => {
    setCurrentCleaningComponent(component);
    setCurrentCleaningType(type);
    if (type === "turmeric") {
      setShowTurmericModal(true);
    } else if (type === "rtc") {
      setShowRtcModal(true);
    } else if (type === "packaging") {
      setShowPackagingModal(true);
    }
  };

  const getCoinMetalDetectorTitle = () => {
    return packagingData.coinMetalDetectorType === "stick"
      ? "Rejector stick & metal detector calibration activity"
      : "Rejector coin & metal detector calibration activity";
  };

  if (!data)
    return <Spinner animation="border" className="d-block mx-auto mt-5" />;

  return (
    <div
      style={{
        maxHeight: "90vh",
        width: "88vw",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <InfoHeader />
      <div className="">
        <div className="row g-4">
          {/* Coriander Section */}
          <div
            className="col-lg-6"
          >
            <div className="card border dashboard-card" onClick={() => navigate("/coriander")}
              style={{ cursor: "pointer" }}>
              <div className="card-header d-flex justify-content-between align-items-center">
                <span className="fs-6 fw-semibold mb-0">Coriander</span>
                <div className="live-icon position-absolute top-0 end-0 m-2">
                  <span className="text-danger text-red-900 text-dark-red text-wight-900 live-badge">
                    Live
                  </span>
                  &nbsp; <span className="dot bg-danger"></span>
                </div>
              </div>
              <div className="card-body">
                <div className="row g-3"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <div className="col-md-4"
                  >
                    <MetricCard
                      title="Sack emptying count (since 7:30 AM)"
                      value={
                        sackCount === 0 ? metrics.totalSackCount : sackCount
                      }
                      icon={<FiShoppingBag className="metric-icon green" />}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Packaging Section */}
          <div
            className="col-lg-6"
          >
            <div className="card border dashboard-card" onClick={() => navigate("/packaging")}
              style={{ cursor: "pointer" }}>
              <div className="card-header d-flex justify-content-between align-items-center">
                <h2 className="fs-6 fw-semibold mb-0">Packaging</h2>
                <div className="live-icon position-absolute top-0 end-0 m-2">
                  <span className="text-danger text-red-900 text-dark-red text-wight-900 live-badge">
                    Live
                  </span>
                  &nbsp; <span className="dot bg-danger"></span>
                </div>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-6"
                    style={{
                      cursor: "pointer",
                      color: "#6c757d",
                      fontSize: "20px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentCleaningComponent("metal_calibration_history");
                      setCurrentCleaningType("packaging");
                      setShowPackagingModal(true);
                    }}
                    title="View cleaning history"
                  >
                    <MetricCard
                      title="Metal detector calibration activity (CCP)"
                      value={packagingData.metalDetectorCalibration}
                      icon={<MdSpeed className="metric-icon green" />}
                      isTimestamp
                    // bgColor="#e8e8eb"
                    />
                  </div>
                  <div className="col-md-6"
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentCleaningComponent("coin_metal_calibration_history");
                      setCurrentCleaningType("packaging");
                      setShowPackagingModal(true);
                    }}
                  >
                    <MetricCard
                      title={getCoinMetalDetectorTitle()}
                      value={packagingData.coinMetalDetectorCalibration}
                      icon={<FiSettings className="metric-icon green" />}
                      isTimestamp
                    // bgColor="#e8e8eb"
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* Turmeric Section */}
          <div className="col-lg-6">
            <div className="card border dashboard-card" onClick={() => navigate("/turmeric")} style={{ cursor: "pointer" }}>
              <div className="card-header d-flex justify-content-between align-items-center">
                <h2
                  className="fs-6 fw-semibold mb-0"
                >
                  Turmeric
                </h2>
                <div className="live-icon position-absolute top-0 end-0 m-2">
                  <span className="text-danger text-red-900 text-dark-red text-wight-900 live-badge">
                    Live
                  </span>
                  &nbsp; <span className="dot bg-danger"></span>
                </div>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div
                    className="col-12"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h6
                      className="fw-medium mb-2"
                      onClick={() => navigate("/turmeric")}
                      style={{ cursor: "pointer" }}
                    >
                      Hopper 1
                    </h6>
                    <div>
                      <Button
                        style={{
                          backgroundColor: "#e03730",
                          border: "none",
                          width: "8.5rem",
                          height: "30px",
                          fontSize: "12px",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentHopper("hopper1");
                          setCurrentRtcComponent(null);
                          setActiveIndex(0);
                          setShowUnsafeModal(true);
                        }}
                      >
                        Unsafe Events - {unsafeEvents.hopper1.length}
                      </Button>
                      <FaHistory
                        className="history-icon"
                        style={{
                          cursor: "pointer",
                          color: "#6c757d",
                          fontSize: "20px",
                          marginLeft: "1rem",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCleaningHistoryClick("hopper1", "turmeric");
                        }}
                        title="View cleaning history"
                      />
                    </div>

                  </div>
                  <div
                    className="col-md-3"
                    onClick={(e) => { e.stopPropagation(); }}
                  >
                    <MetricCard
                      title="Sack emptying count"
                      value={turmericData.hopper1.sackCount}
                      icon={<FiShoppingBag className="metric-icon yellow" />}
                    />
                  </div>
                  <div
                    className="col-md-3"
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentHopper("hopper1");
                      setCurrentRtcComponent(null);
                      setCleaningImage(turmericData.hopper1?.magneticGrillCleaning_image)
                      // setShowCleaningModal(true)
                      handleCleaningHistoryClick("hopper1", "turmeric");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <MetricCard
                      title="Magnetic grill cleaning (CCP)"
                      value={turmericData.hopper1.magneticGrillCleaning}
                      icon={<FaMagnet className="metric-icon yellow" />}
                      isTimestamp
                      showHistoryIcon={true}
                      onHistoryClick={() => handleCleaningHistoryClick("hopper1", "turmeric")}
                    />
                  </div>
                  <div
                    className="col-md-3"
                    onClick={(e) => {
                      e.stopPropagation();

                      if (isCardClickDisabled(turmericData.hopper1.lidPresence, turmericData.hopper1.magneticGrillPresence)) {
                        return;
                      }
                      setCurrentHopper("hopper1");
                      setCurrentCardType("magnetic_grill");
                      setOpenRecentUnsafeEventsModal(true);
                    }}
                    style={{
                      cursor: isCardClickDisabled(turmericData.hopper1.lidPresence, turmericData.hopper1.magneticGrillPresence)
                        ? "not-allowed" : "pointer"
                    }}
                  >
                    <StatusCard
                      title="Magnetic grill"
                      status={turmericData.hopper1.lidPresence === true ? true : turmericData.hopper1.magneticGrillPresence}
                      icon={<FiShield className="status-icon" />}
                      isLidCard={turmericData.hopper1.lidPresence === true}
                      lidPresence={turmericData.hopper1.lidPresence}
                    />
                  </div>
                  <div className="col-md-3"
                    // onClick={(e) => { e.stopPropagation(); setCurrentHopper("hopper1"); setCurrentCardType("safety_mesh"); setOpenRecentUnsafeEventsModal(true); }} 
                    onClick={(e) => {
                      e.stopPropagation();

                      if (isCardClickDisabled(turmericData.hopper1.lidPresence, turmericData.hopper1.safetyMeshPresence)) {
                        return;
                      }
                      setCurrentHopper("hopper1");
                      setCurrentCardType("safety_mesh");
                      setOpenRecentUnsafeEventsModal(true);
                    }}
                    style={{
                      cursor: isCardClickDisabled(turmericData.hopper1.lidPresence, turmericData.hopper1.safetyMeshPresence)
                        ? "not-allowed" : "pointer"
                    }}
                  >
                    <StatusCard
                      title="Safety mesh"
                      status={turmericData.hopper1.lidPresence === true ?
                        true :
                        turmericData.hopper1.safetyMeshPresence}
                      icon={<SiTraefikmesh className="status-icon" />}
                      isLidCard={turmericData.hopper1.lidPresence === true}
                      lidPresence={turmericData.hopper1.lidPresence}
                    />
                  </div>
                </div>

                <div className="row g-3">
                  <div
                    className="col-12"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h6 className="fw-medium mb-2">Hopper 2</h6>
                    <div>
                      <Button
                        style={{
                          backgroundColor: "#e03730",
                          border: "none",
                          width: "8.5rem",
                          height: "30px",
                          fontSize: "12px",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentHopper("hopper2");
                          setCurrentRtcComponent(null);
                          setActiveIndex(0);
                          setShowUnsafeModal(true);
                        }}
                      >
                        Unsafe Events - {unsafeEvents.hopper2.length}
                      </Button>
                      <FaHistory
                        className="history-icon"
                        style={{
                          cursor: "pointer",
                          color: "#6c757d",
                          fontSize: "20px",
                          marginLeft: "1rem",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCleaningHistoryClick("hopper2", "turmeric");
                        }}
                        title="View cleaning history"
                      />
                    </div>
                  </div>
                  <div className="col-md-3"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <MetricCard
                      title="Sack emptying count"
                      value={turmericData.hopper2.sackCount}
                      icon={<FiShoppingBag className="metric-icon yellow" />}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                  </div>
                  <div
                    className="col-md-3"
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentHopper("hopper2");
                      // currentCleaningComponent("");
                      setCurrentRtcComponent(null);
                      setCleaningImage(turmericData.hopper2?.magneticGrillCleaning_image)
                      // setShowCleaningModal(true)
                      handleCleaningHistoryClick("hopper2", "turmeric");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <MetricCard
                      title="Magnetic grill cleaning (CCP)"
                      value={turmericData.hopper2.magneticGrillCleaning}
                      icon={<FaMagnet className="metric-icon yellow" />}
                      isTimestamp
                      showHistoryIcon={true}
                    // onHistoryClick={() => handleCleaningHistoryClick("hopper2", "turmeric")}
                    />
                  </div>
                  <div className="col-md-3"
                    // onClick={(e) => { e.stopPropagation(); setCurrentHopper("hopper2"); setCurrentCardType("magnetic_grill"); setOpenRecentUnsafeEventsModal(true); }} 
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isCardClickDisabled(turmericData.hopper2.lidPresence, turmericData.hopper2.magneticGrillPresence)) {
                        return;
                      }
                      setCurrentHopper("hopper2");
                      setCurrentCardType("magnetic_grill");
                      setOpenRecentUnsafeEventsModal(true);
                    }}
                    style={{
                      cursor: isCardClickDisabled(turmericData.hopper2.lidPresence, turmericData.hopper2.magneticGrillPresence)
                        ? "not-allowed" : "pointer"
                    }}
                  >
                    <StatusCard
                      title="Magnetic grill"
                      status={turmericData.hopper2.lidPresence === true ?
                        true :
                        turmericData.hopper2.magneticGrillPresence}
                      icon={<FiShield className="status-icon" />}
                      isLidCard={turmericData.hopper2.lidPresence === true}
                      lidPresence={turmericData.hopper2.lidPresence}
                    />
                  </div>
                  <div className="col-md-3"
                    // onClick={(e) => { e.stopPropagation(); setCurrentHopper("hopper2"); setCurrentCardType("safety_mesh"); setOpenRecentUnsafeEventsModal(true); }} 
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isCardClickDisabled(turmericData.hopper2.lidPresence, turmericData.hopper2.safetyMeshPresence)) {
                        return;
                      }
                      setCurrentHopper("hopper2");
                      setCurrentCardType("magnetic_grill");
                      setOpenRecentUnsafeEventsModal(true);
                    }}
                    style={{
                      cursor: isCardClickDisabled(turmericData.hopper2.lidPresence, turmericData.hopper2.safetyMeshPresence)
                        ? "not-allowed" : "pointer"
                    }}
                  >
                    <StatusCard
                      title="Safety mesh"
                      status={turmericData.hopper2.lidPresence === true ?
                        true :
                        turmericData.hopper2.safetyMeshPresence}
                      icon={<SiTraefikmesh className="status-icon" />}
                      isLidCard={turmericData.hopper2.lidPresence === true}
                      lidPresence={turmericData.hopper2.lidPresence}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RTC Section */}
          <div
            className="col-lg-6"
          >
            <div className="card border dashboard-card" onClick={() => navigate("/rtc")}
              style={{ cursor: "pointer" }}>
              <div className="card-header d-flex justify-content-between align-items-center">
                <h2 className="fs-6 fw-semibold mb-0">RTC</h2>
                <div className="live-icon position-absolute top-0 end-0 m-2">
                  <span className="text-danger text-red-900 text-dark-red text-wight-900 live-badge">
                    Live
                  </span>
                  <span className="dot bg-danger"></span>
                </div>
              </div>
              <div className="card-body">
                <div
                  className="row g-3"
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      flexDirection: "column",
                      width: "48%",
                      margin: "0.5rem 0 0 0",
                      padding: "0rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h6 className="fw-medium mb-2">Premixer 1</h6>
                      <div>
                        <Button
                          style={{
                            backgroundColor: "#e03730",
                            border: "none",
                            width: "8.5rem",
                            height: "30px",
                            fontSize: "12px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentRtcComponent("premixer1");
                            setCurrentHopper(null);
                            setShowUnsafeModal(true);
                          }}
                        // disabled
                        >
                          Unsafe Events - {rtcUnsafeEvents.premixer1.length}
                        </Button>
                        <FaHistory
                          className="history-icon"
                          style={{
                            cursor: "pointer",
                            color: "#6c757d",
                            fontSize: "20px",
                            marginLeft: "1rem",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCleaningHistoryClick("premixer1", "rtc");
                          }}
                          title="View magnetic grill cleaning history"
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "1rem",
                        width: "100%",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <div className="col-6"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <MetricCard
                          title="Magnetic rod/plate cleaning time (CCP)"
                          value={rtcData.premixer1.magneticRodCleaning}
                          icon={<FaMagnet className="metric-icon purple" />}
                          isTimestamp
                        />
                      </div>
                      <div className="col-6"
                        onClick={(e) => {
                          e.stopPropagation();
                          // Add condition check here
                          if (rtcData.premixer1.lid_presence === true || rtcData.premixer1.safetyMeshLifted === true) {
                            return;
                          }
                          setCurrentRtcComponent("premixer1");
                          setCurrentCardType("safety_mesh");
                          setOpenRecentUnsafeEventsModal(true);
                        }}
                        style={{
                          cursor: (rtcData.premixer1.lid_presence === true || rtcData.premixer1.safetyMeshLifted === true)
                            ? "not-allowed" : "pointer"
                        }}
                      >
                        <StatusCard
                          title="Safety mesh"
                          status={rtcData.premixer1.safetyMeshLifted}
                          icon={<SiTraefikmesh className="status-icon" />}
                          lidPresence={rtcData.premixer1.lid_presence}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      flexDirection: "column",
                      width: "48%",
                      margin: "0.5rem 0 0 0",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h6 className="fw-medium mb-2">Premixer 2</h6>
                      <div>
                        <Button
                          style={{
                            backgroundColor: "#e03730",
                            border: "none",
                            width: "8.5rem",
                            height: "30px",
                            fontSize: "12px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentRtcComponent("premixer2");
                            setCurrentHopper(null);
                            setActiveIndex(0);
                            setShowUnsafeModal(true);
                          }}
                        // disabled
                        >
                          Unsafe Events - {rtcUnsafeEvents.premixer2.length}
                        </Button>
                        <FaHistory
                          className="history-icon"
                          style={{
                            cursor: "pointer",
                            color: "#6c757d",
                            fontSize: "20px",
                            marginLeft: "1rem",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCleaningHistoryClick("premixer2", "rtc");
                          }}
                          title="View magnetic grill cleaning history"
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "1rem",
                        width: "100%",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <div className="col-6"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <MetricCard
                          title="Magnetic rod/plate cleaning time (CCP)"
                          value={rtcData.premixer2.magneticRodCleaning}
                          icon={<FaMagnet className="metric-icon purple" />}
                          isTimestamp
                        />
                      </div>
                      <div className="col-6"
                        onClick={(e) => {
                          e.stopPropagation();
                          // Add condition check here
                          if (rtcData.premixer2.lid_presence === true || rtcData.premixer2.safetyMeshLifted === "present") {
                            return;
                          }
                          setCurrentRtcComponent("premixer2");
                          setCurrentCardType("safety_mesh");
                          setOpenRecentUnsafeEventsModal(true);
                        }}
                        style={{
                          cursor: (rtcData.premixer2.lid_presence === true || rtcData.premixer2.safetyMeshLifted === "present")
                            ? "not-allowed" : "pointer"
                        }}
                      >
                        <StatusCard
                          title="Safety mesh"
                          status={rtcData.premixer2.safetyMeshLifted}
                          icon={<SiTraefikmesh className="status-icon" />}
                          lidPresence={rtcData.premixer2.lid_presence}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      flexDirection: "column",
                      width: "48%",
                      margin: "0",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h6 className="fw-medium mb-2">Final Mixer 1</h6>
                      <div>
                        <Button
                          style={{
                            backgroundColor: "#e03730",
                            border: "none",
                            width: "8.5rem",
                            height: "30px",
                            fontSize: "12px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentRtcComponent("finalmixer1");
                            setCurrentHopper(null);
                            setShowUnsafeModal(true);
                          }}
                        >
                          Unsafe Events - {rtcUnsafeEvents.finalmixer1.length}
                        </Button>
                        <FaHistory
                          className="history-icon"
                          style={{
                            cursor: "pointer",
                            color: "#6c757d",
                            fontSize: "20px",
                            marginLeft: "1rem",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCleaningHistoryClick("finalmixer1", "rtc");
                          }}
                          title="View magnetic grill cleaning history"
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "1rem",
                        width: "100%",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <div className="col-6"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <MetricCard
                          title="Magnetic rod/plate cleaning time (CCP)"
                          value={rtcData.finalmixer1.magneticRodCleaning}
                          icon={<FaMagnet className="metric-icon purple" />}
                          isTimestamp
                        />
                      </div>
                      <div className="col-6"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (rtcData.finalmixer1.lid_presence === true || rtcData.finalmixer1.safetyMeshLifted === "present") {
                            return;
                          }
                          setCurrentRtcComponent("finalmixer1");
                          setCurrentCardType("safety_mesh");
                          setOpenRecentUnsafeEventsModal(true);
                        }}
                        style={{
                          cursor: (rtcData.finalmixer1.lid_presence === true || rtcData.finalmixer1.safetyMeshLifted === "present")
                            ? "not-allowed" : "pointer"
                        }}
                      >
                        <StatusCard
                          title="Safety mesh"
                          status={rtcData.finalmixer1.safetyMeshLifted}
                          icon={<SiTraefikmesh className="status-icon" />}
                          lidPresence={rtcData.finalmixer1.lid_presence}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      flexDirection: "column",
                      width: "48%",
                      margin: "0",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h6 className="fw-medium mb-2">Final Mixer 2</h6>
                      <div>
                        <Button
                          style={{
                            backgroundColor: "#e03730",
                            border: "none",
                            width: "8.5rem",
                            height: "30px",
                            fontSize: "12px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentRtcComponent("finalmixer2");
                            setCurrentHopper(null);
                            setActiveIndex(0);
                            setShowUnsafeModal(true);
                          }}
                        // disabled
                        >
                          Unsafe Events - {rtcUnsafeEvents.finalmixer2.length}
                        </Button>
                        <FaHistory
                          className="history-icon"
                          style={{
                            cursor: "pointer",
                            color: "#6c757d",
                            fontSize: "20px",
                            marginLeft: "1rem",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCleaningHistoryClick("finalmixer2", "rtc");
                          }}
                          title="View magnetic grill cleaning history"
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "1rem",
                        width: "100%",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <div className="col-6"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <MetricCard
                          title="Magnetic rod/plate cleaning time (CCP)"
                          value={rtcData.finalmixer2.magneticRodCleaning}
                          icon={<FaMagnet className="metric-icon purple" />}
                          isTimestamp
                        />
                      </div>
                      <div className="col-6"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (rtcData.finalmixer2.lid_presence === true || rtcData.finalmixer2.safetyMeshLifted === "present") {
                            return;
                          }
                          setCurrentRtcComponent("finalmixer2");
                          setCurrentCardType("safety_mesh");
                          setOpenRecentUnsafeEventsModal(true);
                        }}
                        style={{
                          cursor: (rtcData.finalmixer2.lid_presence === true || rtcData.finalmixer2.safetyMeshLifted === "present")
                            ? "not-allowed" : "pointer"
                        }}
                      >
                        <StatusCard
                          title="Safety mesh"
                          status={rtcData.finalmixer2.safetyMeshLifted}
                          icon={<SiTraefikmesh className="status-icon" />}
                          lidPresence={rtcData.finalmixer2.lid_presence}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div
                      className="grinder-section"
                      style={{ padding: "0 0.75rem", marginTop: "-1.5rem" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          className=""
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "48%",
                            margin: "0",
                            padding: "0rem",
                          }}
                        >
                          <div className="col-12">
                            <h6 className="fw-medium">Grinding 1</h6>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-around",
                              alignItems: "center",
                              gap: "1rem",
                              width: "100%",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <div className="col-md-6">
                              <MetricCard
                                title="Detected Sack count"
                                value={rtcData.grinder1.sackCount.toString()}
                                icon={
                                  <FiShoppingBag className="metric-icon blue" />
                                }
                              // bgColor="#e8e8eb"
                              />
                            </div>
                            <div className="col-md-6">
                              <MetricCard
                                title="Detected Bucket count"
                                value={rtcData.grinder1.bucketCount.toString()}
                                icon={
                                  <FaBucket className="metric-icon blue" />
                                }
                              // bgColor="#e8e8eb"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className=""
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "48%",
                          }}
                        >
                          <div className="col-12">
                            <h6 className="fw-medium">Grinding 2</h6>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-around",
                              alignItems: "center",
                              gap: "1rem",
                              width: "100%",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <div className="col-md-6">
                              <MetricCard
                                title="Detected Sack count"
                                value={rtcData.grinder2.sackCount.toString()}
                                icon={
                                  <FiShoppingBag className="metric-icon blue" />
                                }
                              // bgColor="#e8e8eb"
                              />
                            </div>
                            <div className="col-md-6">
                              <MetricCard
                                title="Detected Bucket count"
                                value={rtcData.grinder2.bucketCount.toString()}
                                icon={
                                  <FaBucket className="metric-icon blue" />
                                }
                              // bgColor="#e8e8eb"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Tape Alignment View</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img
            src={selectedImage}
            alt="Tape Alignment"
            className="img-fluid rounded shadow"
          />
        </Modal.Body>
      </Modal> */}

      <UnsafeEventsModal
        showModal={showUnsafeModal}
        onHide={() => {
          setShowUnsafeModal(false);
          setActiveIndex(0);
        }}
        currentHopper={currentHopper}
        currentRtcComponent={currentRtcComponent}
        unsafeEvents={unsafeEvents}
        rtcUnsafeEvents={rtcUnsafeEvents}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        formatIfTimestamp={formatIfTimestamp}
      />

      <CleaningHistoryModal
        showModal={showTurmericModal}
        onHide={() => setShowTurmericModal(false)}
        currentComponent={currentCleaningComponent}
        turmericCleaningHistory={turmericCleaningHistory}
        cleaningType="turmeric"
      />
      <CleaningHistoryModal
        showModal={showRtcModal}
        onHide={() => setShowRtcModal(false)}
        currentComponent={currentCleaningComponent}
        rtcCleaningHistory={rtcCleaningHistory}
        cleaningType="rtc"
      />
      <CleaningHistoryModal
        showModal={showPackagingModal}
        onHide={() => setShowPackagingModal(false)}
        currentComponent={currentCleaningComponent}
        packagingCleaningHistory={packagingCleaningHistory}
        cleaningType="packaging"
      />
      <CleaningHistoryModal
        showModal={showTapeMissalignmentModal}
        onHide={() => setShowTapeMissalignmentModal(false)}
        currentComponent={currentCleaningComponent}
        packagingTapeMissAlignData={tapeMissalignmentHistory}
        cleaningType="tape_missalignment"
      />
      <RecentUnsafeEventsModal
        showModal={openRecentUnsafeEventsModal}
        onHide={() => setOpenRecentUnsafeEventsModal(false)}
        currentHopper={currentHopper}
        currentRtcComponent={currentRtcComponent}
        currentCardType={currentCardType}
        recentUnsafeEventData={recentUnsafeEventData}
        rtcRecentUnsafeEventData={rtcRecentUnsafeEventData}
        formatIfTimestamp={formatIfTimestamp}
      />
      {/* <Modal
        show={showCleaningModal}
        onHide={() => setShowCleaningModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Magnetic Grill Cleaning
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="carousel-container">
            {currentHopper ? (
              // Turmeric unsafe events
              <>
                <h5>{currentHopper === "hopper1" ? "Hopper 1" : "Hopper 2"}</h5>
                {cleaning_image ? (
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: "2rem auto",
                    }}
                  >
                    <img
                      src={cleaning_image}
                      alt={`Cleaning Image`}
                      className="img-fluid"
                    />
                  </div>
                ) : (<></>)}
              </>
            ) : (
              <></>
            )}
          </div>
        </Modal.Body>
      </Modal> */}
    </div>
  );
};

export default Home;
